import React, { useState, useEffect } from 'react';
import './DialerAdminPanel.css';

const DialerAdminPanel = () => {
    // State for settings
    const [settings, setSettings] = useState({
        campaignId: '',
        dialingMode: 'predictive',
        maxConcurrentCalls: 3,
        targetAnswerRate: 0.3,
        linesPerAgent: 5,
        phoneNumbers: ''
    });

    // State for status
    const [status, setStatus] = useState({
        mode: 'INACTIVE',
        totalCalls: 0,
        answeredCalls: 0,
        answerRate: 0,
        dialRate: 0,
        queueLength: 0,
        retryQueue: 0,
        isActive: false
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSettings(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleStartCampaign = () => {
        // Add campaign start logic here
        setStatus(prev => ({ ...prev, isActive: true }));
    };

    const handleStopCampaign = () => {
        // Add campaign stop logic here
        setStatus(prev => ({ ...prev, isActive: false }));
    };

    return (
        <div className="dialer-page">
            <header className="dialer-header">
                <div className="title-section">
                    <h1>Dialer Control Room</h1>
                    <p className="subtitle">Unleash the Wolf of Wall Street</p>
                </div>
            </header>

            <div className="content-wrapper">
                <section className="control-panel">
                    <div className="panel-header">
                        <h1>Campaign Controls</h1>
                    </div>

                    <div className="settings-group">
                        <div className="form-group">
                            <label>Campaign ID</label>
                            <input
                                type="text"
                                name="campaignId"
                                value={settings.campaignId}
                                onChange={handleInputChange}
                                placeholder="stratton-oakmont-123"
                            />
                        </div>

                        <div className="form-group">
                            <label>Dialing Mode</label>
                            <select
                                name="dialingMode"
                                value={settings.dialingMode}
                                onChange={handleInputChange}
                            >
                                <option value="predictive">Predictive</option>
                                <option value="power">Power</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Max Concurrent Calls</label>
                            <input
                                type="number"
                                name="maxConcurrentCalls"
                                value={settings.maxConcurrentCalls}
                                onChange={handleInputChange}
                                disabled={settings.dialingMode === 'power'}
                                data-tooltip="Not available in power mode - use Lines Per Agent instead"
                            />
                        </div>

                        <div className="form-group">
                            <label>Target Answer Rate</label>
                            <input
                                type="number"
                                step="0.1"
                                name="targetAnswerRate"
                                value={settings.targetAnswerRate}
                                onChange={handleInputChange}
                                disabled={settings.dialingMode === 'power'}
                                data-tooltip="Not available in power mode - manual dialing only"
                            />
                        </div>

                        <div className="form-group">
                            <label>Lines Per Agent</label>
                            <input
                                type="number"
                                name="linesPerAgent"
                                value={settings.linesPerAgent}
                                onChange={handleInputChange}
                                disabled={settings.dialingMode === 'predictive'}
                            />
                            <div className="tooltip">
                                Not available in predictive mode - lines are automatically optimized
                            </div>
                        </div>

                        <div className="campaign-actions">
                            <button
                                className={`campaign-btn start-btn ${status.isActive ? 'disabled' : ''}`}
                                onClick={handleStartCampaign}
                                disabled={status.isActive}
                            >
                                <span className="btn-icon">▶</span>
                                Start Campaign
                            </button>
                            <button
                                className={`campaign-btn stop-btn ${!status.isActive ? 'disabled' : ''}`}
                                onClick={handleStopCampaign}
                                disabled={!status.isActive}
                            >
                                <span className="btn-icon">⬛</span>
                                Stop Campaign
                            </button>
                        </div>
                    </div>
                </section>

                <section className="status-panel">
                    <h1>Live Status</h1>
                    <div className="status-grid" style={{ paddingTop: '24px' }}>
                        <div className="status-item">
                            <h3>Mode</h3>
                            <p>{status.mode}</p>
                        </div>
                        <div className="status-item">
                            <h3>Total Calls</h3>
                            <p>{status.totalCalls}</p>
                        </div>
                        <div className="status-item">
                            <h3>Answered Calls</h3>
                            <p>{status.answeredCalls}</p>
                        </div>
                        <div className="status-item">
                            <h3>Answer Rate</h3>
                            <p>{status.answerRate}%</p>
                        </div>
                        <div className="status-item">
                            <h3>Dial Rate</h3>
                            <p>{status.dialRate}/sec</p>
                        </div>
                        <div className="status-item">
                            <h3>Queue Length</h3>
                            <p>{status.queueLength}</p>
                        </div>
                        <div className="status-item">
                            <h3>Retry Queue</h3>
                            <p>{status.retryQueue}</p>
                        </div>
                        <div className="status-item">
                            <h3>Status</h3>
                            <p className={status.isActive ? 'active' : 'inactive'}>
                                {status.isActive ? 'Active' : 'Inactive'}
                            </p>
                        </div>
                    </div>
                    <h3>Progress</h3>
                    <div className="progress-bar">
                        <div 
                            className="progress-fill"
                            style={{ width: `${status.answerRate}%` }}
                        />
                    </div>
                </section>
            </div>
        </div>
    );
};

export default DialerAdminPanel;
